import { z } from 'zod';

/** Placeholder — extend when adding contact-specific validation. */
export const contactSliceSchema = z.object({ id: z.number().optional() });
export type contactSliceSchemaValues = z.infer<typeof contactSliceSchema>;
